/**
 * File: Article.js
 * Origin: isotect
 * Description: [TODO: Description]
 *
 * Version: v1.0.2
 * Created: 2025-11-25
 * Last Updated: 2026-02-06
 *
 * Used By: isotect
 * Maintainer: Zachary Dicks
 *
 * Notes:
 * - Changes in this file may affect all consuming frontend modules.
 * - See Git repository 'isotect' for full change history.
 */

// Third-party packages
import { useLayoutEffect, useState } from "react";

// Local project files
import ArticleHeadline from "../ui/ArticleHeadline";

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function FeatureArticle({ reverse, headline, description, image }) {
    const [uiWidth, setUiWidth] = useState(() => window.innerWidth);

    useLayoutEffect(() => {
        const handleResize = () => setUiWidth(window.innerWidth);
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const shouldReverse = uiWidth > 600 && reverse;

    return (
        <>
            <div className="feature-article">
                {shouldReverse ? (
                    <>
                        <img
                            src={image}
                            className="feature-article__image"
                        ></img>
                        <ArticleHeadline
                            headline={headline}
                            description={description}
                        />
                    </>
                ) : (
                    <>
                        <ArticleHeadline
                            headline={headline}
                            description={description}
                        />
                        <img
                            src={image}
                            className="feature-article__image"
                        ></img>
                    </>
                )}
            </div>
        </>
    );
}

/**
 * [TODO: Component description here]
 *
 * @param {Object} props - Component properties
 * @returns {JSX.Element} [TODO: Rendered output]
 */
function Article({ type, data }) {
    switch (type) {
        case "feature":
            return <FeatureArticle {...data} />;
        default:
            return null;
    }
}

export default Article;
